/*
  PIXEL STORE - Complementos (cross-sell con descuento).
  El cartel, los precios y la configuracion estan en snippets/pixel-complementos.liquid;
  aca solo esta el movimiento: que cuatro juegos se muestran, donde se coloca el
  bloque, que estado toma y como agrega el producto al carro. Se separo del snippet
  porque juntos pasaban el limite de tamano de la API de temas.
*/
(function () {
  if (window.__pixelCx) return;
  window.__pixelCx = true;

  // La configuracion viaja en el HTML del bloque (snippets/pixel-complementos.liquid).
  var raiz = document.querySelector('[data-pixel-cx]');
  var PCT = parseInt((raiz && raiz.getAttribute('data-cx-pct')) || '0', 10);
  var REGALO = parseInt((raiz && raiz.getAttribute('data-cx-regalo')) || '0', 10);
  var interno = false;

  // El snippet dibuja TODA la coleccion y aca se eligen cuatro al azar en cada
  // visita, para que el que vuelve no vea siempre los mismos. Se saca de la tombola
  // el juego que la persona esta mirando: ofrecerle como complemento lo que ya tiene
  // al frente no suma nada. La eleccion se hace una sola vez por carga: si se
  // rehiciera en cada redibujado, las tarjetas cambiarian solas mientras el cliente
  // las mira.
  function elegir(bloque) {
    if (bloque.getAttribute('data-cx-elegido')) return;
    var ficha = bloque.getAttribute('data-cx-ficha') || '';
    var cuantos = parseInt(bloque.getAttribute('data-cx-cuantos') || '4', 10);
    var items = [].slice.call(bloque.querySelectorAll('[data-cx-item]'));
    var aptos = items.filter(function (n) {
      return !ficha || n.getAttribute('data-cx-producto') !== ficha;
    });
    for (var i = aptos.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = aptos[i]; aptos[i] = aptos[j]; aptos[j] = t;
    }
    items.forEach(function (n) { n.hidden = true; });
    aptos.slice(0, cuantos).forEach(function (n) { n.hidden = false; });
    bloque.setAttribute('data-cx-elegido', '1');
  }

  function ids() {
    var lista = [];
    document.querySelectorAll('[data-cx-item]').forEach(function (n) {
      var v = parseInt(n.getAttribute('data-cx-variante'), 10);
      if (v && lista.indexOf(v) === -1) lista.push(v);
    });
    return lista;
  }

  function pedir(url, datos) {
    interno = true;
    var o = { method: datos ? 'POST' : 'GET', headers: { 'Accept': 'application/json' } };
    if (datos) { o.headers['Content-Type'] = 'application/json'; o.body = JSON.stringify(datos); }
    return fetch(url, o).then(function (r) { return r.json(); }).finally(function () { interno = false; });
  }

  function enCajon(bloque) {
    var seccion = bloque.closest('.shopify-section');
    return seccion && seccion.querySelector('cart-drawer') !== null;
  }

  // Sube desde un nodo hasta el hijo directo del contenedor. null si no cuelga de ahi.
  function hijoDirecto(nodo, cont) {
    var n = nodo;
    while (n && n.parentNode !== cont) { n = n.parentNode; }
    return n;
  }

  // Dos mudanzas: el bloque del carrito lateral se dibuja fuera del cajon y hay
  // que meterlo dentro; el de la ficha nace pegado al precio y tiene que bajar.
  //
  // EN LA FICHA VA JUSTO ARRIBA DE "QUE PASA DESPUES DE QUE PAGAS" (.pixel-ruta),
  // que en estas landings es lo que viene despues del carrusel de comentarios. Se
  // ancla en la ruta y no en un numero de seccion porque cada landing tiene distinta
  // cantidad de bloques. Si esa ficha no tuviera la ruta, cae debajo del boton de
  // compra, que es donde estaba antes.
  function acomodar() {
    var cont = document.querySelector('.product__info-container');
    document.querySelectorAll('[data-pixel-cx]').forEach(function (bloque) {
      if (enCajon(bloque)) {
        var seccion = bloque.closest('.shopify-section');
        var pie = seccion.querySelector('.cart-drawer__footer, .drawer__footer');
        if (pie && pie.parentNode && bloque.parentNode !== pie.parentNode) {
          pie.parentNode.insertBefore(bloque, pie);
        }
        return;
      }
      if (!cont || !cont.contains(bloque)) return;
      var fijo = cont.querySelector('[data-cx-fijo]');
      if (fijo && fijo !== bloque) { bloque.remove(); return; }

      var ruta = cont.querySelector('.pixel-ruta');
      var anclaRuta = ruta ? hijoDirecto(ruta, cont) : null;
      if (anclaRuta) {
        bloque.setAttribute('data-cx-fijo', '');
        if (anclaRuta.previousElementSibling !== bloque) cont.insertBefore(bloque, anclaRuta);
        return;
      }

      var forma = cont.querySelector('product-form');
      var anclaForma = forma ? hijoDirecto(forma, cont) : null;
      if (!anclaForma) return;
      bloque.setAttribute('data-cx-fijo', '');
      if (anclaForma.nextElementSibling !== bloque) cont.insertBefore(bloque, anclaForma.nextSibling);
    });
  }

  function pintar(estado, texto, avance) {
    document.querySelectorAll('[data-pixel-cx]').forEach(function (bloque) {
      // Solo se muestran los que ya estan en su sitio: cualquier copia suelta
      // (la que deja el re-dibujado, la barra pegajosa) se queda escondida.
      var colocado = enCajon(bloque) || bloque.hasAttribute('data-cx-fijo');
      if (estado === 'oculto' || !colocado) { bloque.hidden = true; return; }
      elegir(bloque);
      bloque.hidden = false;
      var t = bloque.querySelector('[data-cx-titulo]');
      var b = bloque.querySelector('[data-cx-barra]');
      var l = bloque.querySelector('[data-cx-lista]');
      if (t) t.innerHTML = texto;
      if (b) b.style.width = avance + '%';
      if (l) l.style.display = estado === 'listo' ? 'none' : '';
    });
  }

  function revisar() {
    return pedir('/cart.js').then(function (carro) {
      var complementos = ids();
      var hayRegalo = false, hayComplemento = null, hayPrincipal = false;

      (carro.items || []).forEach(function (i) {
        if (i.properties && i.properties._regalo) { hayRegalo = true; return; }
        if (i.id === REGALO) { hayRegalo = true; return; }
        if (complementos.indexOf(i.id) !== -1) { hayComplemento = i; return; }
        // Principal: cualquier otra cosa que no sea FC 27, que esta excluido
        // del descuento porque ya tiene su propio regalo.
        if ((i.product_title || '').toUpperCase().indexOf('FC 27') === -1) hayPrincipal = true;
      });

      // Marca los que ya estan en el carro.
      document.querySelectorAll('[data-cx-item]').forEach(function (n) {
        var v = parseInt(n.getAttribute('data-cx-variante'), 10);
        var puesto = (carro.items || []).some(function (i) { return i.id === v; });
        var btn = n.querySelector('[data-cx-agregar]');
        if (btn) { btn.disabled = puesto; btn.textContent = puesto ? 'Agregado' : 'Agregar'; }
      });

      if (hayComplemento && hayPrincipal) {
        pintar('listo', 'Listo: <b>' + hayComplemento.product_title + '</b> se lleva ' + PCT + '% de descuento en tu pedido.', 100);
      } else if (hayPrincipal) {
        pintar('abierto', 'Suma uno de estos y <b>te queda con ' + PCT + '% menos</b>. Solo uno por pedido.', 55);
      } else if (hayRegalo) {
        // Carro con el regalo de FC 27: el descuento de complementos no aplica.
        pintar('oculto', '', 0);
      } else {
        pintar('abierto', 'Agrega cualquier juego y uno de estos <b>te queda con ' + PCT + '% menos</b>.', 15);
      }
      acomodar();
    }).catch(function () {});
  }

  function refrescar() {
    if (location.pathname.indexOf('/cart') === 0) { location.reload(); return; }
    fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        try {
          var dp = new DOMParser();
          if (s['cart-drawer']) {
            var nuevo = dp.parseFromString(s['cart-drawer'], 'text/html').querySelector('cart-drawer');
            var actual = document.querySelector('cart-drawer');
            if (nuevo && actual) { actual.innerHTML = nuevo.innerHTML; actual.classList.remove('is-empty'); }
          }
          if (s['cart-icon-bubble']) {
            var burbuja = document.getElementById('cart-icon-bubble');
            var nb = dp.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('#cart-icon-bubble');
            if (burbuja && nb) burbuja.innerHTML = nb.innerHTML;
          }
        } catch (e) {}
      })
      .catch(function () {})
      .then(function () { setTimeout(revisar, 300); });
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-cx-agregar]');
    if (!btn) return;
    var item = btn.closest('[data-cx-item]');
    if (!item) return;
    var v = parseInt(item.getAttribute('data-cx-variante'), 10);
    if (!v) return;
    ev.preventDefault();
    btn.disabled = true;
    btn.textContent = 'Agregando...';
    pedir('/cart/add.js', { items: [{ id: v, quantity: 1 }] })
      .then(function () { refrescar(); })
      .catch(function () { btn.disabled = false; btn.textContent = 'Agregar'; });
  });

  // Se engancha a los movimientos del carro que haga el tema.
  var fetchOriginal = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    if (typeof url !== 'string' && url && url.url) url = url.url;
    var esCarro = typeof url === 'string' && url.indexOf('/cart/') !== -1 && !interno;
    var p = fetchOriginal.apply(this, arguments);
    if (esCarro) p.then(function () { setTimeout(revisar, 400); }).catch(function () {});
    return p;
  };

  // Dawn redibuja el bloque de precio al cambiar de variante y el cajon al tocar
  // el carro: hay que volver a acomodar lo que aparezca.
  var pendiente = null;
  function vigilar() {
    if (!window.MutationObserver) return;
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = setTimeout(function () { pendiente = null; acomodar(); }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function arrancar() { acomodar(); revisar(); vigilar(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();